import React from "react";
import "./members.css";

export const AllMembers = (props) => {
  return (
    <div className="big-box">
      <div className="heading">
        <h1>{props.heading}</h1>
      </div>
      <div className="medium-box-2">
        
        <ul>
          {props.Name.map((Name, index) => {
            return (
              <li className="member-li">{`${props.Name[index]} ${props.Info[index]}`}</li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
